import { z } from "zod/v4";

import { BaseVoucherSchema } from "@common/schemas/VoucherSchema";

export const VoucherCartSchema = z.object({
  purchaserEmail: z.string().nullable(),
  uuid: z.string(),
});

export const VoucherCheckoutSchema = z.object({
  uuid: z.string(),
  originatorId: z.string(),
  originatorType: z.string(),
  userId: z.string().nullable(),
  userType: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type VoucherCart = z.infer<typeof VoucherCartSchema>;

export const VoucherSchema = BaseVoucherSchema.extend({
  code: z.string(),
  giftMessage: z.string().nullable(),
  purchaserName: z.string().nullish(), // Not add to the api ...yet
  qrCode: z.string(),
});
export const OldVoucherSchema = z.object({
  uuid: z.string(),
  venueUuid: z.string(),
  venueName: z.string().nullable(),
  purchaserUuid: z.string().nullable(),
  purchaserName: z.string().nullish(), // Not add to the api ...yet
  ownerUuid: z.string().nullable(),
  issuerUuid: z.string().nullable(),
  voucherTemplateUuid: z.string().nullable(),
  staffMemberUuid: z.string().nullable(),
  recipientName: z.string().nullable(),
  recipientEmail: z.string().nullable(),
  purchaserEmail: z.string().nullable(),
  giftMessage: z.string().nullable(),
  purchasePriceInCents: z.number().int(),
  openingBalanceInCents: z.number().int(),
  balanceInCents: z.number().int(),
  marketingDescription: z.string().nullable(),
  voucherName: z.string().nullable(),
  code: z.string().nullable(),
  qrCode: z.string().nullable(),
  shareEmail: z.boolean().default(false),
  claimedAt: z.string().nullable(),
  expiresAt: z.string(),
  creationReason: z.string().nullish(),
  creationChannel: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  senderName: z.string().nullable(),
});

export const VouchersSchema = z.array(VoucherSchema);
export type Voucher = z.infer<typeof VoucherSchema>;
